import * as React from 'react'
import { isEmpty } from 'lodash'
import styled from 'styled-components'

import { Action } from '~/components'
import { useFilters } from '~/hooks'
import { useFiltersState } from '~/hooks/use-filters-state'
import Label from '~/truck/label'

import { SelectedFilterTags } from '../selected-filter-tags'

interface HeaderProps {
  className?: string
}

const StyledContainer = styled.div`
  flex-shrink: 0;
  padding: ${props => props.theme.spacing.cozy * 1.5}px;
`

const StyledTitleContainer = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
`
const StyledSelectedFilterTags = styled(SelectedFilterTags)`
  padding-top: ${props => props.theme.spacing.comfortable}px;
`

const StyledAction = styled(Action)`
  font-size: ${props => props.theme.spacing.cozy * 1.75}px;
`

export function Header(props: HeaderProps) {
  const { className } = props

  const { selectedTags } = useFilters()

  const { clearFilters } = useFiltersState()

  const hasSelectedTags = !isEmpty(selectedTags)

  return (
    <StyledContainer>
      <StyledTitleContainer className={className}>
        <Label as="h4" $textStyle="h5Semibold" $color="grayscale80">
          Filtrar por
        </Label>
        {hasSelectedTags && (
          <StyledAction $color="info" onClick={() => clearFilters()} $textStyle="h6Regular">
            Limpiar filtros
          </StyledAction>
        )}
      </StyledTitleContainer>
      {hasSelectedTags && <StyledSelectedFilterTags />}
    </StyledContainer>
  )
}
